
export enum Features
{
    Base = 0,
    DRIVE = 1,
    ACADEMY = 2,
    IRDRIVE = 4,
    ACEDRIVE = 8,
    ACDRIVE = 16,
    AMSDRIVE = 32
}
const FeatureNames: Record<Features, string> = {
  [Features.Base]: "Base", // Wird nicht genutzt
  [Features.DRIVE]: "ACC DRIVE",
  [Features.ACADEMY]: "ACC Academy",
  [Features.IRDRIVE]: "iR DRIVE",
  [Features.ACEDRIVE]: "ACE DRIVE",
  [Features.ACDRIVE]: "AC DRIVE",
  [Features.AMSDRIVE]: "AMS DRIVE"
};
export const hasFlag = (role: Features, flag: Features): boolean => {
  return (role & flag) === flag;
};

export const listApps = (flag: Features): string[] => {
  return Object.entries(Features)
      .filter(([key, value]) => 
          typeof value === "number" && value !== Features.Base && (flag & (value as Features)) !== 0
      )
      .map(([key]) => key);
};

export const ListAppsNames = (flag: Features): string[] => {
  return Object.entries(Features)
      .filter(([key, value]) => 
          typeof value === "number" && value !== Features.Base && (flag & (value as Features)) !== 0
      )
      .map(([_, value]) => FeatureNames[value as Features] || "Unknown");
};